<template>
    <h2
      class="title"
      :style="{
        fontSize: info.form.fontSize + 'px',
        color: info.form.color,
        backgroundColor: info.form.backgroundColor,
        }">
      {{info.form.text}}
    </h2>
</template>

<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseTitle',
  mixins: [ baseComponentMixins ],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  min-height: 58px;
  line-height: 58px;
  padding: 12px;
  margin-bottom: 15px;
  display: inline-block;
  font-size: 16px;
  font-weight: normal;
  padding: 0 20px;
  border-radius: 6px;
  &:hover{
    background: #f6f7ff;
  }
}
</style>